exports.APP_LABEL = 'web';
exports.RESULTS_PER_PAGE = 10;
exports.MAINLINE_ADS_TOTAL = 3;
exports.SIDEBAR_ADS_TOTAL = 3;
exports.PAGINATION_DYNAMIC = 'dynamicPagination';
exports.PAGINATION_STATIC = 'staticPagination';
exports.IMAGES_SNIPPET_PER_PAGE_DEFAULT = 4;
exports.WEB_PRODUCT_ADS_FULLWIDTH_EXPERIMENT = 've-product-ads-fullwidth';
exports.SHOPPING_BING_EXPERIMENT = 'jo-shopping-bing';
